import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import styles from './PartAvailabilityIndicator.module.css';
import { Popover, Paper, IconButton } from '@material-ui/core';
import { CheckCircle } from '../../icons';

const green = '#49a47e';
const grey = 'grey';

const AvailabilityInfoPopup = ({ isAvailable }) => {
  let heading = 'Scan incomplete';
  let content = 'Part availability is not confirmed';

  if (isAvailable) {
    heading = 'Scan complete';
    content = 'Part is available';
  }

  const fillColor = isAvailable ? green : grey;

  return (
    <Paper className={styles.availabilityPopup}>
      <span className={styles.subtitle}>{heading}</span>
      <span className={styles.content}>
        <CheckCircle
          style={{ color: fillColor }}
          className={styles.smallCheck}
        />
        <span className={styles.contextText}>{content}</span>
      </span>
    </Paper>
  );
};

const PartAvailabilityIndicator = ({ availability, partNumber, ...props }) => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const iconRef = useRef(null);

  const openPopup = () => setIsPopupOpen(true);
  const closePopup = () => setIsPopupOpen(false);

  const fillColor = availability ? green : grey;

  return (
    <>
      <IconButton
        style={{ padding: 0, color: fillColor }}
        aria-label={`check-part-availability-${partNumber}`}
        onClick={openPopup}
        ref={iconRef}
      >
        <CheckCircle style={{ fontSize: '1.5em' }} {...props} />
      </IconButton>
      <Popover
        open={isPopupOpen}
        anchorEl={iconRef.current}
        onClose={closePopup}
        anchorOrigin={{
          vertical: 'right',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'left',
          horizontal: 'left',
        }}
      >
        <AvailabilityInfoPopup isAvailable={availability} />
      </Popover>
    </>
  );
};

PartAvailabilityIndicator.propTypes = {
  availability: PropTypes.bool.isRequired,
  partNumber: PropTypes.string.isRequired,
};

export default PartAvailabilityIndicator;
